import UploadedFileInfo from './uploaded-file-info';

export default UploadedFileInfo;